import React, { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";
import { getProducts } from "../middleware/productsFetch"
import Spinner from './Spinner';
import { Link } from "react-router-dom";
import bannerImg from "../assets/images/productBanner.png"


const ITEMS_PER_PAGE = 8;

const Products = () => {
    const { category } = useParams();
    const [allProducts, setAllProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        setLoading(true);
        setCurrentPage(1); // reset when category changes

        getProducts()
            .then((data) => {
                setAllProducts(data[category] || []);
            })
            .catch(() => setAllProducts([]))
            .finally(() => setLoading(false));
    }, [category]);

    if (loading) return <Spinner />;

    const totalPages = Math.ceil(allProducts.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const currentItems = allProducts.slice(
        startIndex,
        startIndex + ITEMS_PER_PAGE
    );

    const openDetails = (product) => {
        setSelectedProduct(product);
    };

    const closeDetails = () => {
       setSelectedProduct(null);
    };

    // const handleGetQuote = () => {
    //     setShowQuote(true);
    // };

    return (
        <div>
            {/* Quote Modal Instance */}
            {/* <QuoteModal
                show={showQuote}
                onClose={() => setShowQuote(false)}
                initialProduct={selectedProduct ? selectedProduct.name : ''}
            /> */}

            {/* Product Details Modal */}
            {selectedProduct && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1050 }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header border-0 pb-0">
                                <button type="button" className="btn-close" onClick={closeDetails}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6 mb-3 mb-md-0 text-center">
                                        <img src={selectedProduct.image} className="img-fluid rounded" alt={selectedProduct.name} style={{ maxHeight: '400px', objectFit: 'contain' }} />
                                    </div>
                                    <div className="col-md-6">
                                        <h2 className="fw-bold">{selectedProduct.name}</h2>
                                        <hr className="text-primary" style={{ width: '50px', opacity: 1, height: '3px' }} />
                                        <p className="text-muted">{selectedProduct.desc}</p>

                                        <div className="mb-4">
                                            <h6 className="fw-bold text-uppercase text-secondary small">Brands / Availability</h6>
                                            <p className="mb-0">{selectedProduct.brands}</p>
                                        </div>

                                        <div className="d-grid gap-2">
                                            <button className="btn btn-outline-secondary" onClick={closeDetails}>
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="container-fluid px-0 mb-5">
                <div className="position-relative text-center">
                    <img src={bannerImg} className="img-fluid w-100" style={{ height: '350px', objectFit: 'cover' }} alt="Banner" />
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ background: 'rgba(0,0,0,0.5)' }}>
                        <h1 className="fw-bold text-white display-3" style={{ textTransform: "uppercase", letterSpacing: '2px' }}>{category}</h1>
                    </div>
                </div>
            </div>

            <div className="container mb-5">
                <Link className='btn btn-outline-secondary mb-4 rounded-pill px-4' to="/"><i className="fa-solid fa-arrow-left me-2"></i> All Categories</Link>

                {currentItems.length === 0 ? (
                    <div className="text-center py-5">
                        <h3 className="text-muted">No products found in this category.</h3>
                        <Link to="/" className="btn btn-primary mt-3">Browse Categories</Link>
                    </div>
                ) : (
                    <>
                        <div className="row g-4">
                            {currentItems.map((p) => (
                                <div key={p.id} className="col-lg-3 col-md-4 col-sm-6">
                                    <div className="card h-100 border-0 shadow-sm product-card">
                                        <div style={{ height: '250px', overflow: 'hidden', position: 'relative', cursor: 'pointer' }} onClick={() => openDetails(p)}>
                                            <img src={p.image} className="card-img-top w-100 h-100" style={{ objectFit: 'contain', padding: '1rem' }} alt={p.name} />
                                            <div className="product-overlay d-flex justify-content-center align-items-center">
                                                <button className="btn btn-light rounded-pill px-3 shadow-sm fw-bold">View Details</button>
                                            </div>
                                        </div>

                                        <div className="card-body text-center d-flex flex-column">
                                            <h5 className="card-title fw-bold text-dark cursor-pointer" onClick={() => openDetails(p)}>{p.name}</h5>
                                            <p className="card-text text-muted small">
                                                {p.desc.length > 60 ? p.desc.substring(0, 60) + '...' : p.desc}
                                            </p>
                                            <div className="mt-auto">
                                                <button className="btn btn-outline-primary btn-sm rounded-pill px-3" onClick={() => openDetails(p)}>
                                                    View Details
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                        {/* Pagination Controls */}
                        {totalPages > 1 && (
                            <div className="d-flex justify-content-center mt-5 gap-2">
                                <button className="btn btn-outline-dark"
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage((p) => p - 1)}
                                >
                                    <i className="fa-solid fa-chevron-left"></i>
                                </button>

                                <span className="align-self-center px-3 fw-bold">
                                    {currentPage} / {totalPages}
                                </span>

                                <button className="btn btn-outline-dark"
                                    disabled={currentPage === totalPages}
                                    onClick={() => setCurrentPage((p) => p + 1)}
                                >
                                    <i className="fa-solid fa-chevron-right"></i>
                                </button>
                            </div>
                        )}

                        <style jsx>{`
                            .product-card:hover {
                                box-shadow: 0 10px 25px rgba(0,0,0,0.1) !important;
                                transform: translateY(-5px);
                                transition: all 0.3s ease;
                            }
                            .product-overlay {
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 100%;
                                height: 100%;
                                background: rgba(0,0,0,0.05);
                                opacity: 0;
                                transition: opacity 0.3s;
                            }
                            .product-card:hover .product-overlay {
                                opacity: 1;
                            }
                        `}</style>
                    </>
                )}
            </div>
        </div>
    );
};

export default Products;